<template>
  <multi-select-filter
    :id="filterData.key + '-filter'"
    :label="filterData.label"
    :current-set-value="selectedOptions"
    :get-value="getOptions"
    :multiple="true"
    :update-method="updateValue"
    track-by="key"
    display-value="title"
  />
</template>

<script>
import MultiSelectFilter from "../MultiSelectFilter.vue";
import RaftRestClient from "../../../lib/raft_rest_client.js";

export default {
  name: "OgStandardRefFilter",
  data() {
    return {
      opts: null,
      selectedOptions: [],
    };
  },
  props: {
    filterData: {
      type: Object,
      required: true,
    },
  },
  components: {
    MultiSelectFilter,
  },
  computed: {
    getOptions: function () {
      if (this.opts) {
        return this.opts;
      }
      if (
        typeof this.filterData.displaySettings.third_party_settings
          .bioraft_core_components === "undefined"
      ) {
        return [];
      }
      if (
        typeof this.filterData.displaySettings.third_party_settings
          .bioraft_core_components.rest_path !== "undefined"
      ) {
        const path =
          this.filterData.displaySettings.third_party_settings
            .bioraft_core_components.rest_path;
        const dataKey =
          this.filterData.displaySettings.third_party_settings
            .bioraft_core_components.rest_key;
        RaftRestClient.getRest(
          path,
          {},
          (data) => {
            this.opts = this.getOptsFromRestResult(data[dataKey]);
          },
          this.errorEmit,
          this,
        );
      }
      return [];
    },
  },
  methods: {
    updateValue: function (values) {
      const cleanValues = [];
      values.forEach((valueData) => {
        cleanValues.push(valueData.key);
      });
      this.selectedOptions = values;
      this.$emit("update-filters", this.filterData.key + ".id", cleanValues);
      this.$emit("update-filter", {
        id: this.filterData.key,
        value: cleanValues,
      });
    },
    getOptsFromRestResult: function (data) {
      const opts = [{ key: 0, title: "- Any -" }];
      Object.keys(data).forEach((key) => {
        opts.push({ key: data[key].uuid, title: data[key].title });
      });
      return opts;
    },
  },
};
</script>
